import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'lowy-delete-modal',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">{{headline}}</div>
      <div class="subheading" *ngIf="subheading">{{subheading}}</div>
      <!-- <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="delete()">delete</span>
      </div> -->
      <div class="row">
        <div class="col-2">
          <button mat-button class="lowy-btn-clear" (click)="cancel()">cancel</button>
        </div>
        <div class="col-2">
          <button mat-button class="lowy-btn-std" (click)="submit()">delete</button>
        </div>
      </div>
    </div>
  </lowy-modal>
  `
})
export class DeleteConfirmationModalComponent {
  public data: any;
  public headline: string;
  public subheading: string;

  @Output() delete: EventEmitter<null>;
  @ViewChild('modal') modal: ModalComponent;

  constructor() {
    this.delete = new EventEmitter();
  }

  public open(options?: DeleteModalOptions) {
    this.data = options.data;
    this.headline = options.headline;
    this.subheading = options.subheading;
    this.modal.open();
  }

  public submit() {
    this.delete.emit(this.data);
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}

export class DeleteModalOptions {
  data?: any;
  headline: string;
  subheading?: string;
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modals/delete-confirmation-modal.component.ts